import React, { useEffect, useState } from "react";
import MenuItem from "../../components/admin/menu/MenuItem";
import {useDocumentTitle} from "../../hooks";
import BackendLayout from "../../layouts/BackendLayout";
import { useDispatch } from "react-redux";
import {getDepartmentTopPageSettings} from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import {DEPARTMENT_MASTER_DASHBOARD} from "../../constants/routes";
import {PageTitle, RedirectAlert} from "../../components";
import {clearPageLoading, setPageLoading} from "../../store/actions";
import {errorStatusHandle} from "../../utils";
import {DEPARTMENT_MASTER_DASHBOARD_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";

const DepartmentTopPage = () => {
  useRedirectPage(DEPARTMENT_MASTER_DASHBOARD_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("部門マスタトップ - 点検王");
  const breadcrumb = getRouteBreadcrumb(DEPARTMENT_MASTER_DASHBOARD);

  //Function help to set page settings
  const setTopPageSettings = async (e) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getDepartmentTopPageSettings();
      dispatch(setPageSettings(pageSettings));
      setMenuItems(pageSettings.menu_items);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  useEffect(() => {
    setTopPageSettings().then();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BackendLayout breadcrumb={breadcrumb} sidebar={true}>
      <PageTitle title="部門マスタトップ"/>
      <RedirectAlert />
      <div className="grid grid-cols-2 lg:grid-cols-3  gap-x-8 gap-y-8 py-[20px] max-w-[1160px]">
        {menuItems.map((item, index) => (
            <MenuItem key={index} menu={item.name} feature="department" />
        ))}
      </div>
    </BackendLayout>
  );
};

export default DepartmentTopPage;